export const getLabel = (displayNamePath: string[] = []) =>
  displayNamePath
    .map(l => l?.trim?.())
    .filter(Boolean)
    .join(' / ');
